export default __webpack_public_path__ + "static/media/promotions.77dd3380.svg";